// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"209e1c86","289":"7f8161a6"}[chunkId] + ".chunk.js";
};